module.exports = __webpack_public_path__ + "img/construction.658397ca.svg";